import { TableColumn } from '../../table/DataTable.types';

export const columns: TableColumn[] = [
  {
    accessor: 'name',
    name: 'page.bank-account.col-name',
  },
  {
    accessor: 'number',
    name: 'page.bank-account.col-number',
  },
  {
    accessor: 'iban',
    name: 'page.bank-account.col-iban',
  },
  {
    accessor: 'swift',
    name: 'page.bank-account.col-swift',
  },
];
